import { render, staticRenderFns } from "./ModalCompanies.vue?vue&type=template&id=d9c5bcd6"
import script from "./ModalCompanies.vue?vue&type=script&lang=js"
export * from "./ModalCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports